import React from 'react';
import styled from 'styled-components';

import { COLORS } from '../../app/common/constants/styles';
import Button from '../../app/common/components/Button';
import { TranslationHelpers } from '../../i18n/translationHelpers';
import ICONS from '../../app/common/constants/icons';
import Icon from '../../app/common/components/Icon';
import { addRatEvent } from '../../utils/ratClickEvents';
import { MYR_STANDALONE_CLIENT_ID } from '../../app/app.constants';

const LoginContainer = styled.div<{ margin: true | undefined }>`
    display: flex;
    align-items: center;
    padding-top: 8px;
    margin-right: ${(props) => (props.margin ? '25px' : '0px')};
`;

const LoginButtonWrapper = styled.a`
    font-weight: 600;
    padding: 0;
    max-width: 100%;
    color: ${COLORS.rakutenRed};
    cursor: pointer;
    align-items: center;
    display: flex;

    span {
        text-align: center;
        position: relative;
        padding-bottom: 4px;
    }

    span::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: 0;
        left: 0;
        background-color: #bf0000;
        visibility: hidden;
        transform: scaleX(0);
        transition: all 0.3s ease-in-out 0s;
    }
    span:hover:before {
        visibility: visible;
        transform: scaleX(1);
    }
`;

const IconContainer = styled.div`
    color: ${COLORS.rakutenRed};
`;

export const loginRedirectForStandaloneClient = async (appConfig: Record<string, any>) => {
    appConfig &&
        window.location.assign(
            `${appConfig.OMNI_API_HOST}/sso/authorize?client_id=${MYR_STANDALONE_CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${appConfig.CALLBACK_URL}start?clientId=${MYR_STANDALONE_CLIENT_ID}`,
        );
};

export const registrationRedirectForStandaloneClient = (appConfig: Record<string, any>) => {
    appConfig &&
        window.location.assign(
            `${appConfig.OMNI_API_HOST}/sso/register?client_id=${MYR_STANDALONE_CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${appConfig.CALLBACK_URL}start?clientId=${MYR_STANDALONE_CLIENT_ID}`,
        );
};

export const SigninButton = (props: any) => {
    return (
        <LoginContainer margin={props.margin}>
            <LoginButtonWrapper
                onClick={() => {
                    addRatEvent('about', 'login');
                    loginRedirectForStandaloneClient(props?.appConfig);
                }}
            >
                <span>{TranslationHelpers.getFormattedMessage('visitor.signin.rakuten.btn')}</span>
            </LoginButtonWrapper>
            <IconContainer>
                <Icon size="24" icon={ICONS.ARROW_RIGHT} />
            </IconContainer>
        </LoginContainer>
    );
};

export const SignupButton = (props: any) => {
    return (
        <Button
            id="create-rakuten-id"
            primary={true}
            width="225px"
            height="36px"
            text={TranslationHelpers.getMessageDescriptor('visitor.signup.rakuten.btn')}
            type="button"
            border="round"
            icon={(<Icon icon={ICONS.ARROW_RIGHT} />) as any}
            iconPosition="Right"
            onClick={() => {
                addRatEvent('about', 'registration');
                registrationRedirectForStandaloneClient(props?.appConfig);
            }}
            success={false}
            disabled={false}
        />
    );
};

export const SigninButtonMobile = (props: any) => {
    return (
        <Button
            id="my-id"
            primary={true}
            height="36px"
            text={TranslationHelpers.getMessageDescriptor('visitor.signup.my.id.btn')}
            type="button"
            border="round"
            icon={(<Icon icon={ICONS.ARROW_RIGHT} />) as any}
            iconPosition="Right"
            onClick={() => {
                addRatEvent('about', 'myid');
                loginRedirectForStandaloneClient(props?.appConfig);
            }}
            success={false}
            disabled={false}
        />
    );
};

export const MobileDeviceCheck = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function () {
        return (
            MobileDeviceCheck.Android() ||
            MobileDeviceCheck.BlackBerry() ||
            MobileDeviceCheck.iOS() ||
            MobileDeviceCheck.Opera() ||
            MobileDeviceCheck.Windows()
        );
    },
};
